// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Data types
import {
  discountIncentiveCore,
  discountIncentiveListing
} from '../../../data-types/discountIncentive';

// This component
export default function DiscountIncentive() {
  // Data types
  const { endpoint } = discountIncentiveCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters
  } = discountIncentiveListing();

  // Listing
  const {
    page,
    setPage,
    pageSize,
    setPageSize,
    activeFilters,
    saveActiveFilters,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'data-type',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        page,
        setPage,
        pageSize,
        setPageSize,
        activeFilters,
        saveActiveFilters,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Discounts &amp; Incentives"
        buttonNewLabel="New Discount/Incentive"
        buttonNewUrl="/discount/new"
        exportAction={true}
        buttonExportLabel="Export Data"
      />
    </ListingContext.Provider>
  );
}
